import type {
  BrandRevenueSummaryQuery,
  BrandRevenueTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { BrandReportStore } from "@src/components/modules/reports/brand/common/store";
import { BrandRevenueModel } from "@src/components/modules/reports/brand/revenue/models";
import { action, makeObservable, observable } from "mobx";
import { createContext, useContext } from "react";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);

export class Store {
  readonly key = "brandRevenue";
  reportStore: BrandReportStore;
  @observable brands: BrandRevenueModel[] = [];
  @observable
  summary?: BrandRevenueSummaryQuery["brandRevenueSummary"];

  constructor() {
    makeObservable(this);
    this.reportStore = new BrandReportStore(this.key);
  }

  @action setTableData(query: BrandRevenueTableDataQuery) {
    this.brands = query.brandRevenue.result.map(
      (i) => new BrandRevenueModel(i),
    );
    this.reportStore.setExpenseBudgetCategories(
      query.expenseBudgetCategories ?? [],
    );

    if (query.brandRevenue.paginatorInfo) {
      this.reportStore.pagination.setFromPaginatorInfo(
        query.brandRevenue.paginatorInfo,
      );
    }
  }

  @action setSummary(query: BrandRevenueSummaryQuery) {
    this.summary = query.brandRevenueSummary;
  }
}
